import { toDate as o } from "./toDate.js";
function r(e) {
  const t = o(e);
  return t.setSeconds(0, 0), t;
}
export {
  r as default,
  r as startOfMinute
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfMinute.js
// module id = 1404
// module chunks = 41